import React from 'react';
import './WhyChooseUs.css';

function WhyChooseUs() {
  return (
    <section className="why-choose-section">
      <div className="why-choose-container">
        {/* Dark Why Choose DSMR Banner */}
        <div className="why-choose-banner">
          <div className="banner-header">WHY CHOOSE DSMR</div>
          <div className="banner-grid">
            
            <div className="banner-item">
              <svg className="banner-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 12"></polyline>
              </svg>
              <h3 className="banner-item-title">Fast Turnaround</h3>
              <p className="banner-item-desc">
                Most services completed within <span className="highlight-orange">30 minutes</span>
              </p>
            </div>

            <div className="banner-item">
              <svg className="banner-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              <h3 className="banner-item-title">Doorstep Service</h3>
              <p className="banner-item-desc">
                We come to your home or office
              </p>
            </div>

            <div className="banner-item">
              <svg className="banner-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <polyline points="9 11 11 13 15 9"></polyline>
              </svg>
              <h3 className="banner-item-title">Warranty</h3>
              <p className="banner-item-desc">
                Covered by up to <span className="highlight-orange">1 year</span> warranty
              </p>
            </div>

            <div className="banner-item">
              <svg className="banner-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
              <h3 className="banner-item-title">Quality Guaranteed</h3>
              <p className="banner-item-desc">
                100% genuine parts & certified experts
              </p>
            </div>

            <div className="banner-item">
              <svg className="banner-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                <line x1="9" y1="12" x2="15" y2="12"></line>
                <line x1="9" y1="16" x2="13" y2="16"></line>
              </svg>
              <h3 className="banner-item-title">Affordable Pricing</h3>
              <p className="banner-item-desc">
                Transparent pricing, no hidden charges
              </p>
            </div>

            <div className="banner-item">
              <svg className="banner-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <polyline points="16 11 18 13 22 9"></polyline>
              </svg>
              <h3 className="banner-item-title">Customer Satisfaction</h3>
              <p className="banner-item-desc">
                Rated <span className="highlight-orange">4.9/5</span> by our customers
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default WhyChooseUs;
